import React from 'react';
import { useNavigate } from 'react-router-dom';
import GoBackArrowIcon from '../utils/icons/GoBakcArrowIcon';
import '../styles/components/CustomHeader.css';

interface CustomHeaderProps {
  logoText?: string;
}

const CustomHeader: React.FC<CustomHeaderProps> = ({ logoText = "RushHour" }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <header className="custom-header">
      <div className="header-content">
        <button onClick={handleGoBack} className="go-back-button">
          <GoBackArrowIcon size={24} className="go-back-icon" />
        </button>
        <div className="header-logo">
          <img 
            src={require('../assets/images/RushHour_logo_v2.png')} 
            alt="RushHour Logo" 
            className="logo-img" 
          />
          <span className="logo-text">{logoText}</span>
        </div>
        <div className="header-spacer"></div>
      </div>
    </header>
  );
};

export default CustomHeader;
